export default "__VITE_PUBLIC_ASSET__510c0f08__"